<template>
  <div>
    <div class="header_wrap">
      <div class="header_block">
        <ul class="ul_wrap">
          <li
            :class="[indexId == item.id ? 'chageTap' : '']"
            v-for="item in navList"
            :key="item.id"
            @click="changeType(item.id)"
          >
            <span>
              {{ item.name }}
            </span>
          </li>
        </ul>
        <!-- 语言切换 -->
        <el-dropdown trigger="click" @command="handleLangChange">
          <div class="lang-change">
            <img src="../assets/images/langs.png"/>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
            v-for="(item, index) in langs"
            :key="index"
            :command="item.value"
            :style="currentLang.value == item.value ? `background: #a4282e!important;color: #fff!important;` : ''"
            >{{ item.label }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 搜索框 -->
        <div class="search_wrap">
			    <el-input
          :placeholder="currentLang.config.navbar.searchPlaceholder"
          v-model="searchKeywords"
          @input="handleInput">
			      <el-button
              icon="el-icon-search"
              size="mini"
              slot="append"
              class="search-btn"
              @click="handleSearch"
			      ></el-button>
			    </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'


export default {
  inject: ['reload'],

  emits: ['on-search'],

  data() {
    return {
      searchKeywords: "",
      indexId: "",
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    ...mapState([
      'langs'
    ]),
    navList() {

      const navbar = this.currentLang.config.navbar

      return [
        {
          id: 1,
          name: navbar.home,
        },
        {
          id: 2,
          name: navbar.about,
        },
        {
          id: 3,
          name: navbar.applicationArea,
        },
        {
          id: 4,
          name: navbar.production,
        },
        {
          id: 5,
          name: navbar.news,
        },
        {
          id: 6,
          name: navbar.joinIn,
        },
      ]
    },
    searchType() {
      return this.currentLang.config.navbar.searchType;
    }
  },

  created() {
    this.searchKeywords = 
      sessionStorage.getItem('searchKeywords') != undefined && sessionStorage.getItem('searchKeywords') != null ?
      sessionStorage.getItem('searchKeywords') :
      this.searchKeywords
  },

  mounted() {
    if (this.$route.path === "/") {
      this.indexId = 1;
    }
    if ( this.$route.path === "/about") {
      this.indexId = 2;
    }
    if (this.$route.path === "/yyly") {
      this.indexId = 3;
    }
    if (this.$route.path === "/cpzy" || this.$route.path === "/detail") {
      this.indexId = 4;
    }
    if (this.$route.path === "/news" || this.$route.path === "/nText") {
      this.indexId = 5;
    }
    if (this.$route.path === "/joinIn" ) {
      this.indexId = 6;
    }
  },
  methods: {
    ...mapMutations([
      'changeLang'
    ]),


    // 语言切换回调
    handleLangChange(e) {
      e && this.changeLang(e)
    },
    
    handleInput(val) {
      sessionStorage.setItem('searchKeywords', val)
    },
	  handleSearch() {
      if (this.$route.path == '/search') {
       this.$emit('on-search', this.searchKeywords)
      }
      else {
        this.$router.push("/search")
      }
	  },
    changeType(id) {
      this.indexId = id;
      switch (this.indexId) {
        case 1:
          this.$router.push("/");
          break;
        case 2:
          
          this.$router.push("/about");
          this.reload();
          // this.$router.push({
          //   path:'about',
          //   query:{activeName:'0'}
          // })
          break;
        case 3:
          this.$router.push("/yyly");
          break;
        case 4:
          this.$router.push("/cpzy");
          break;
        case 5:
          this.$router.push("/news");
          break;
        case 6:
          this.$router.push("/joinIn");
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.header_wrap {
  width: 100%;
  height: 40px;
  background: #e8363e;
  .header_block {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    .ul_wrap {
      height: 100%;
      display: flex;
      align-items: center;
      li {
        height: 100%;
        padding: 0 20px;
        line-height: 40px;
        span {
          color: #fff;
          cursor: pointer;
        }
      }
      .chageTap {
        background: #a4282e;
      }
    }
    .search_wrap {
      // width: 280px;
      height: 100%;
      background: #b1292e;
      /deep/ .el-input-group {
        height: 100%;
      }
      /deep/ .el-input {
        background: #b1292e;
        .el-input__inner {
          height: 100%;
          padding: 0 6px 0 12px;
          background-color: #b1292e;
          border: none;
          color: #fff;
        }
        .el-input__inner::placeholder {
          color: #fff;
        }
        .el-input__icon {
          color: #fff;
        }
      }

      /deep/ .el-input-group__prepend {
        padding: 0 10px;
        border: 0;
        border-radius: 0;
        background-color: transparent;
      }
    }
    .change_wrap {
      display: flex;
      align-items: center;
      margin-left: 20px;
      font-size: 14px;
      color: #fff;
      .shu {
        margin: 0 10px;
      }
      .chinese_wrap,
      .english_wrap {
        cursor: pointer;
      }
    }
  }
}

.lang-change {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 20px;
  cursor: pointer;

  &:hover {
    background: #a4282e;
  }

  img {
    width: 25px;
    height: 25px;
  }
}

.el-dropdown-menu {
  background-color: #e8363e;
  color: #fff;
  border: 0;
}

.el-dropdown-menu__item,
.el-dropdown-menu__item--divided:before {
  background-color: #e8363e;
  color: #fff;
  border: 0;
}

</style>
<style>
	.el-input-group__append{
		  border: none !important;
		  border-color: #b1292e !important;
	}

.el-popper[x-placement^=bottom] .popper__arrow::after {
  top: 0px!important;
  background-color: transparent!important;
  border-bottom-color: #e8363e!important;
}

.el-dropdown-menu__item:hover {
  background: #a4282e!important;
  color: #fff!important;
}

.search-btn {
  background-color: #b1292e!important;
  border-color: #b1292e!important;
  color: white!important;
  height: 40px!important;
  border-radius: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue